<div class="flex-row content-between p-24 column-ms column-md "
    [ngClass]="{'row-gap-ms-50 row-gap-md-16':!showTransaction}">
    <div class="full d-flex-md content-center d-none">
        <button type="button" class="height-4-px width-6 border-radius-8 tw-border-0 tw-p-0"
            style="background-color: #E9E9E9;" (click)="closeDialog()" [ngClass]="{'mb-md-50':showTransaction}"
            aria-label="Close"></button>
    </div>
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0  d-block-ms d-none-imp d-none-md text-right"
        aria-label="Close Dialog" (click)="closeDialog()">
        <x-icon class="cursor-pointer" [iconColor]="'#000000'" [width]="'32px'" [height]="'32px'"></x-icon>
    </button>
    <ng-container *ngIf="!showTransaction && data">
        <div class="bg-color-685CF0 border-radius-24 flex-row align-center content-center border-radius-md-16 ptb-md-8">
            <img class="d-none-md" src="assets/refer-earn/claim-reward.svg" alt="Claim reward">
            <img class="d-none d-block-md mb-50" src="assets/refer-earn/claim-reward-md.svg" alt="Claim reward">
        </div>
        <div class="flex-row column align-center row-gap-48 content-center mt-md-50">
            <h2 class="fs-32 fw-7 text-black text-center fs-md-24 fw-md-8">Redeem {{reward.amount | currency:
                'INR':'symbol':'1.0-0'}}
                <p class="fs-16 fw-4 pt-8 pb-18 fs-md-14 max-width-md-24">Your cash reward will be sent the below UPI ID
                </p>
            </h2>
            <div class="flex-row align-center column row-gap-24">
                <div *ngIf="!this.currentUser.name">
                    <p class="fs-14 color-202028 d-none d-block-md pb-8">Name</p>
                    <input [formControl]="name" type="text"
                        class="bg-color-F6F6FE border-radius-8 border-color-D9D6FA width-36 ptb-19 plr-16 width-ms-28"
                        [ngClass]="{'border-blue-1':name.value}" placeholder="Name" specialChar
                        aria-label="Enter your name">
                    <p class="fs-12 text-danger" *ngIf="upiId.touched&&!name.value">Name is required</p>
                </div>
                <div>
                    <p class="fs-14 color-202028 d-none d-block-md pb-8">Enter UPI ID</p>
                    <div class="flex-row align-center column-md column-gap-24 row-gap-24">
                        <input [formControl]="upiId" type="text" aria-label="Enter your upi id"
                            class="bg-color-F6F6FE border-radius-8 border-color-D9D6FA width-36 ptb-19 plr-16 width-ms-28"
                            [ngClass]="{'border-blue-1':upiId.value}" placeholder="Ex: pickright@okhdfc">
                        <!-- <p class="text-blue cursor-pointer fw-6" *ngIf="">Verify</p> -->
                        <img src="assets/refer-earn/icon-tick.svg" alt="Tick"
                            *ngIf="upiId.valid&&(currentUser.razorpay.fundAccountVPA === upiId.value)">
                        <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0"
                            *ngIf="upiId.valid&&isExist&&(currentUser?.razorpay?.fundAccountVPA !== upiId.value)"
                            class="cursor-pointer" (click)="saveUserDetail()">
                            <img src="assets/refer-earn/refresh.svg" alt="Referesh">
                        </button>
                    </div>
                    <p class="fs-12 text-danger mt-8" *ngIf="upiId.touched&&upiId.invalid">Please enter correct UPI ID
                    </p>
                </div>
                <button type="button" class="btn btn-primary" [disabled]="upiId.invalid" *ngIf="!isExist"
                    (click)="saveUserDetail()">Save</button>
            </div>
            <button type="button" class="btn btn-primary mb-md-48 full-md" (click)="claimReward()" *ngIf="isExist"
                [ngClass]="{'disabled': disabledBtn||(currentUser.razorpay.fundAccountVPA !== upiId.value)}">Claim
                Reward</button>
        </div>
    </ng-container>
    <ng-container *ngIf="showTransaction">
        <ng-container *ngIf="transaction.success">
            <div class="flex-row column align-center row-gap-24 full">
                <img src="assets/refer-earn/icon-success.svg" alt="Success" class="max-width-8 max-width-md-10">
                <div class="flex-row column align-center row-gap-24 width-65-pr mt-20 full-md">
                    <h2 class="fs-32 fw-7 color-202028 fs-md-24">Transaction Initiated</h2>
                    <!-- <div class="flex-row full color-202028 content-around flex-wrap-md row-gap-12">
                         <p class="fw-7 fs-md-14">Date: <span class="fw-4 ml-16">25/06/2023</span></p>
                         <p class="fw-7 fs-md-14">Txn ID.: <span class="fw-4 ml-16">45YJUDJUFJU456</span></p>
                         <p class="fw-7 fs-md-14">Amount: <span class="fw-4 ml-16">Rs.500</span></p>
                    </div> -->
                </div>
                <button type="button" class="btn btn-primary mt-56 width-38 pb-10" (click)="closeDialog()">Lets Earn
                    More</button>
            </div>
        </ng-container>
        <!-- <ng-container>
            <div class="flex-row column align-center row-gap-md-24 full row-gap-16">
                <div class="flex-row column color-202028 row-gap-8 text-center mtb-md-90 mt-90 mb-40">
                    <h2 class="fs-32 fw-7 fs-md-24">Transaction Pending</h2>
                    <p>Pending transaction may take up to 2-3 working days to be credited </p>
                </div>
                <button class="btn btn-primary width-39 full-md" (click)="closeDialog()">Sure, Lets wait</button>
                <button class="btn btn-outline border-none bg-none" (click)="goToSupport()">Contact Support</button>
            </div>
        </ng-container> -->
        <ng-container *ngIf="transaction.failed">
            <div class="flex-row column align-center full row-gap-24">
                <img src="assets/refer-earn/icon-failed.svg" alt="Failed">
                <div class="color-202028 text-center mb-12 mb-md-60">
                    <h2 class="fs-32 fw-7 fs-md-24">Transaction Failed</h2>
                    <p>Please contact support for more info on this issue.</p>
                </div>
                <button type="button" class="btn btn-primary width-39 full-md" (click)="closeDialog()">Ok</button>
                <button type="button" class="btn btn-outline border-none bg-none" (click)="goToSupport()">Contact
                    Support</button>
            </div>
        </ng-container>
    </ng-container>
    <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0 d-none-ms d-none-md" (click)="closeDialog()"
        aria-label="Close dialog">
        <x-icon class="cursor-pointer " [iconColor]="'#000000'" [width]="'32px'" [height]="'32px'"
            aria-hidden="true"></x-icon>
    </button>
</div>